<div class="drop-down-icon refresh-rate-container d-flex align-items-center">
  <button mat-button class="ub-button ub-button-radius" [matMenuTriggerFor]="menu" aria-label="" [disabled]='disableRefreshRate' [disableRipple]="true" matTooltipClass="ub-tooltip" matTooltip="{{'auto_refresh' | translate}}" matTooltipClass="ub-tooltip" matTooltip="{{'auto_refresh' | translate}}" matTooltipPosition="left">
    @if (displayAutoIcon) {
      <ubi-cell-icons name="autostate-icon"></ubi-cell-icons>
    }
    @if (!displayAutoIcon) {
      <ubi-cell-icons name="offstate-icon"></ubi-cell-icons>
    }
  </button>

  <mat-menu class="refresh-rate-menu" #menu="matMenu" xPosition="before">
    @for (refreshRate of applicableRefreshRateOpt; track refreshRate) {
      <button mat-menu-item (click)="choseRespectiveRefreshRate(refreshRate.refresh_rate_key)" [ngClass]="refreshRate.isSelectedRefreshRate ? 'selected-list': ''">
        <span>{{ refreshRate.refresh_rate_value | translate }}</span>
      </button>
    }
  </mat-menu>
</div>
